module.exports = __webpack_public_path__ + "static/photo-c720e85973b2373d79d32c80e5db7937.jpg";